import { useFilterStore } from "./store";
import { hidePreloader, showPreloader } from "../../components/preloader";
import { updateHtml } from "../../components/pager";
import { getFetchOptions } from "../../utils";
const DELAY = 750;
export default function useFilterAPI() {
    const store = useFilterStore();
    let requestId = 0;
    let abortController;
    let delayTimeout;
    function request(url, params = {}, options = {}) {
        const currentRequestId = ++requestId;
        return fetch(url, {
            ...getFetchOptions(Object.assign(params, {
                values: store.values,
                config: store.config,
            }), true),
            ...options,
        })
            .then(response => requestId > currentRequestId ? Promise.reject('concurrency error') : response)
            .then(response => response.json())
            .then((json) => {
            if (json.items) {
                store.update(json.items);
            }
            if (json.sort) {
                store.setDefaultSort(json.sort.default);
                store.setSortType(json.sort.type);
                store.setSortTypes(json.sort.types);
            }
            return json;
        })
            .catch(reason => {
            if (reason === 'concurrency error') {
                return {};
            }
        })
            .finally(() => store.setLoaded(true));
    }
    function updateResults(status, { page = 1, pager = false, loadMore = false, lockFilter = false, pushState = true, url, } = {}) {
        showPreloader(pager ? undefined : (lockFilter ? document.getElementById('filter-area') : document.querySelector('.catalog_items')));
        return request('/api/filter/results', { status, page }, abortController ? { signal: abortController.signal } : {})
            .then(response => {
            if (response && response.pager !== undefined && response.results !== undefined) {
                abortController = null;
                updateHtml(response.results, pager && !loadMore, response.pager, loadMore);
                url = url ?? response.url;
                if (pushState && url !== undefined && url !== document.location.search) {
                    const state = {
                        config: { ...store.config },
                        values: { ...store.values },
                        page,
                        title: document.querySelector('h1').innerText,
                        html: response.results,
                        pagerHtml: response.pager,
                        available: store.available,
                    };
                    window.history.pushState(state, null, url === '' ? './' : url);
                }
                hidePreloader();
            }
            return response;
        });
    }
    function cancelTimeout() {
        if (delayTimeout) {
            clearTimeout(delayTimeout);
            delayTimeout = null;
        }
    }
    function updateResultsDelayed(status) {
        return new Promise((resolve, reject) => {
            cancelTimeout();
            if (abortController) {
                abortController.abort('cancelled');
            }
            const ac = abortController = new AbortController();
            abortController.signal.addEventListener('abort', () => {
                cancelTimeout();
                reject('cancelled');
            });
            delayTimeout = setTimeout(() => {
                if (ac.signal.aborted) {
                    reject('cancelled');
                }
                delayTimeout = null;
                updateResults(status)
                    .then(response => resolve(response));
            }, DELAY);
        });
    }
    return {
        request, updateResults: updateResults, updateResultsDelayed
    };
}
